import React from "react";
import useFetch from "react-fetch-hook";
import { ColorProps, PositionProps } from "styled-system";

import { processResponse } from "../Navigation/navigation.functions";
import CareersHeader from "./CareersHeader";

export interface HeaderProps extends ColorProps, PositionProps {
  /**
    Urls to fetch data and execute login logout and register actions
  */
  urls: {
    navLinks: string; // url to get the structure of links for the main navigation
  };
  variant: "transparent" | "white";
  idHighlighted?: string;
}

export default function CareersHeaderWithAPI({
  urls,
  variant,
  ...props
}: HeaderProps) {
  const { data: navLinks } = useFetch(urls.navLinks);

  const defaultNavItems = [
    {
      id: "1",
      shouldOpenInNewWindow: false,
      label: "Welcome",
      link: "https://www.bca.co.uk/careers/welcome",
      isVisible: true,
    },
    {
      id: "2",
      shouldOpenInNewWindow: false,
      label: "All jobs",
      link: "https://www.bca.co.uk/careers/jobs",
      isVisible: true,
    },
  ];

  const processedNavLinks = processResponse(navLinks);

  return (
    <CareersHeader
      variant={variant}
      navItems={
        processedNavLinks.length > 0 ? processedNavLinks : defaultNavItems
      }
      {...props}
    ></CareersHeader>
  );
}
